import { lastWorkspaceKey } from "@baton/core";
import { useI18n } from "@baton/i18n";
import { Button } from "@baton/ui";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router";
import { useRuntime } from "../app/RuntimeProvider.tsx";
import { useUiStore } from "../app/uiStore.ts";
import { useRouteMeta } from "../routes/meta.ts";

/**
 * FR-015-090, `contracts/screens.md` § Error and utility screens: the not-found panel at
 * `*` with Go to my work and Open the palette. Outside a workspace the palette has no
 * targets, so the second action is present only inside one.
 */
export function NotFound() {
  const { t } = useI18n();
  const runtime = useRuntime();
  const navigate = useNavigate();
  const { ws } = useParams();
  const openPalette = useUiStore((state) => state.setPaletteOpen);
  const heading = useRef<HTMLHeadingElement>(null);
  useRouteMeta({ screen: "notFound.title", focus: heading });
  const workspace = ws ?? runtime.storage.get(lastWorkspaceKey);
  return (
    <div className="b-not-found">
      <h1 ref={heading} tabIndex={-1} className="b-not-found__title">
        {t("notFound.title")}
      </h1>
      <p className="b-not-found__body">{t("notFound.body")}</p>
      <div className="b-not-found__actions">
        <Button
          variant="primary"
          onClick={() => {
            void navigate(workspace === null ? "/" : `/${workspace}/my-work`);
          }}
        >
          {t("notFound.goToMyWork")}
        </Button>
        {ws !== undefined && (
          <Button
            variant="secondary"
            onClick={() => {
              openPalette(true);
            }}
          >
            {t("notFound.openPalette")}
          </Button>
        )}
      </div>
    </div>
  );
}
